module.exports = __webpack_public_path__ + "img/airpods.52ecd2cb.svg";